import { HOT_LIST } from "@/mocks/guaData";
import SectionHeading from "./SectionHeading";

function trendIcon(trend: "up" | "down" | "new") {
  if (trend === "new") {
    return (
      <span className="grid h-6 w-6 place-items-center rounded-md bg-primary-500 text-background-50">
        <i className="ri-flashlight-fill text-xs"></i>
      </span>
    );
  }
  if (trend === "up") {
    return <i className="ri-arrow-up-line text-primary-500"></i>;
  }
  return <i className="ri-arrow-down-line text-accent-600"></i>;
}

function rankColor(rank: number) {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-primary-400 text-background-50";
  if (rank === 3) return "bg-primary-300 text-primary-900";
  return "bg-background-200 text-foreground-600";
}

export default function GuBang() {
  return (
    <section id="gubang" className="mx-auto max-w-7xl px-4 md:px-6 py-16">
      <div className="grid gap-8 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <SectionHeading
            kicker="今日瓜榜"
            title="当下最热，前排围观"
            desc="按实时热度排序的热门事件话题榜，帮助吃瓜群众快速锁定现在最有讨论度、最值得前排吃瓜的事件。"
          />
          <div className="mt-6 flex flex-wrap gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600">
              <i className="ri-time-line text-accent-600"></i>
              每 15 分钟更新
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-600">
              <i className="ri-team-line text-primary-500"></i>
              10 万+ 瓜友在线
            </span>
          </div>

          <div className="mt-8 rounded-xl bg-background-100 p-5">
            <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <i className="ri-question-line text-primary-500"></i>
              瓜榜是什么？
            </h3>
            <p className="mt-3 text-sm leading-6 text-foreground-700">
              瓜榜综合讨论量、转发量与新增围观人次生成，热度数字越大表示当下越多人正在前排吃瓜。想看热闹？点开榜上前排就对了。
            </p>
          </div>
        </div>

        <div className="lg:col-span-3">
          <ol className="grid gap-3">
            {HOT_LIST.map((item) => (
              <li
                key={item.rank}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 px-4 py-3 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
              >
                <span
                  className={`grid h-8 w-8 shrink-0 place-items-center rounded-md text-sm font-bold ${
                    rankColor(item.rank)
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <a
                    href="#guatian"
                    className="block truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700 md:text-base"
                  >
                    {item.title}
                  </a>
                  <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded bg-background-200 px-1.5 py-0.5 text-accent-700">{item.tag}</span>
                    <span>热度 {item.heat}w</span>
                  </div>
                </div>
                <div className="grid h-8 w-6 shrink-0 place-items-center">
                  {trendIcon(item.trend)}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}